import { Id, ProfileCustomValue } from "PFCore/types";

import { SkillsTable } from "../../../common/skills_table";
import { SkillsViewCommonProps } from "../../skills_section.types";
import { SkillsEmptyState } from "../skills_empty_state";

type SkillsUngroupedViewProps = {
  skills: ProfileCustomValue[];
  profileId: Id;
} & SkillsViewCommonProps;

export const SkillsUngroupedView = ({
  skills,
  searchTerm,
  setSearchTerm,
  ...props
}: SkillsUngroupedViewProps) =>
  skills.length ? (
    <SkillsTable skills={skills} {...props} />
  ) : (
    <SkillsEmptyState searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
  );
